/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How Fuel entry fees are calculated (FIAT = USD converted to Fuel at registration, FIXED = exact Fuel quantity)
 * @export
 */
export const EntryFeeUnit = {
    FIAT: 'FIAT',
    FIXED: 'FIXED'
} as const;
export type EntryFeeUnit = typeof EntryFeeUnit[keyof typeof EntryFeeUnit];


export function instanceOfEntryFeeUnit(value: any): boolean {
    for (const key in EntryFeeUnit) {
        if (Object.prototype.hasOwnProperty.call(EntryFeeUnit, key)) {
            if (EntryFeeUnit[key as keyof typeof EntryFeeUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EntryFeeUnitFromJSON(json: any): EntryFeeUnit {
    return EntryFeeUnitFromJSONTyped(json, false);
}

export function EntryFeeUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryFeeUnit {
    return json as EntryFeeUnit;
}

export function EntryFeeUnitToJSON(value?: EntryFeeUnit | null): any {
    return value as any;
}

export function EntryFeeUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): EntryFeeUnit {
    return value as EntryFeeUnit;
}

